module.exports = __webpack_public_path__ + "static/media/ScareEmOff.746b0a4b.png";